import React from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '@actual-app/components/button';
import { View } from '@actual-app/components/view';

import { cor, espaco, texto } from '#components/finapp/estilo';

export const JANELAS = [3, 6, 12] as const;
export type Janela = (typeof JANELAS)[number];

type Props = {
  janela: Janela;
  onMudar: (j: Janela) => void;
};

/** Chips de 3 / 6 / 12 meses. O escolhido fica preenchido com o verde da marca. */
export function JanelaSeletor({ janela, onMudar }: Props) {
  const { t } = useTranslation();

  return (
    <View style={{ flexDirection: 'row', gap: 8 }} data-testid="janela-seletor">
      {JANELAS.map(j => {
        const ativo = j === janela;
        return (
          <Button
            key={j}
            variant="bare"
            onPress={() => onMudar(j)}
            aria-pressed={ativo}
            style={{
              ...texto.rotuloTabela,
              backgroundColor: ativo ? cor.acento : cor.neutroFraco,
              color: ativo ? '#ffffff' : cor.tintaFraca,
              borderRadius: espaco.raioPequeno,
              padding: '6px 14px',
            }}
          >
            {t('{{n}} meses', { n: j })}
          </Button>
        );
      })}
    </View>
  );
}
